import { HomeHowItWorksStepCardData } from "@/design-system/Molecules/HowItWorksStepCard/stepCard.config";

export const homeHowItWorksConfig = {
  heading: "How it Works",
  items: HomeHowItWorksStepCardData,
  highlightedHeadingMain: "Access Common Oral ED Meds and",
  highlightedHeadingAccent: "extra-strength Trimix injections in no time.",
};
